export default "__VITE_ASSET__BDJf7xrH__ 374w";